// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__14_15","topBottomGutter":"Layout_topBottomGutter__I7LiB"};